exports.formatarCNPJ = (cnpj) => {
    const regex = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;
    return cnpj?.replace(regex, '$1.$2.$3/$4-$5');
};

exports.formatCep = (cep) => {
    const cleaned = cep?.replace(/\D/g, '');
    return cleaned?.replace(/(\d{5})(\d{3})/, '$1-$2');
};

exports.formatTelefoneFixo = (telefone) => {
    const cleaned = telefone?.replace(/\D/g, '');
    return cleaned?.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
};

exports.formatCPF = (cpf) => {
    const cleaned = cpf?.replace(/\D/g, '');
    return cleaned?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

exports.formatPrice = (preco) => {
    if (preco != null) {
        const precoStr = typeof preco === 'string' ? preco.replace(',', '.') : preco;
        const price = parseFloat(precoStr);

        if (isNaN(price)) return "0,00";

        let precoFormatado = price.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        return precoFormatado;
    } else {
        return "0,00";
    }
};



exports.gerarDatasPorIntervaloAupRN = (inicioStr, quantidade) => {
    if (!inicioStr || typeof inicioStr !== 'string') return [];

    const [dia, mes, ano] = inicioStr.split('/').map(Number);
    if (!dia || !mes || !ano) return [];

    const inicio = new Date(ano, mes - 1, dia);
    if (isNaN(inicio)) return [];

    const datas = [];
    let diasTotal = 0;

    for (let i = 0; i < quantidade; i++) {
        diasTotal += i === 0 ? 30 : 15;

        const novaData = new Date(inicio.getTime());
        novaData.setTime(inicio.getTime() + diasTotal * 24 * 60 * 60 * 1000);

        const diaFormatado = String(novaData.getDate()).padStart(2, '0');
        const mesFormatado = String(novaData.getMonth() + 1).padStart(2, '0');
        const anoFormatado = novaData.getFullYear();

        datas.push(`${diaFormatado}/${mesFormatado}/${anoFormatado}`);
    }

    return datas;
};



exports.gerarDatasPorIntervalo = (inicioStr, quantidade, intervaloDias) => {
    if (!inicioStr || typeof inicioStr !== 'string') return [];

    const [dia, mes, ano] = inicioStr.split('/').map(Number);
    if (!dia || !mes || !ano) return [];

    const inicio = new Date(ano, mes - 1, dia);
    if (isNaN(inicio)) return [];

    const datas = [];

    for (let i = 0; i < quantidade; i++) {
        const novaData = new Date(inicio);
        novaData.setDate(inicio.getDate() + (i + 1) * intervaloDias);

        const diaFormatado = String(novaData.getDate()).padStart(2, '0');
        const mesFormatado = String(novaData.getMonth() + 1).padStart(2, '0');
        const anoFormatado = novaData.getFullYear();

        datas.push(`${diaFormatado}/${mesFormatado}/${anoFormatado}`);
    }

    return datas;
};

exports.dateNow = () => {
    const agora = new Date();
    const horas = agora.getHours().toString().padStart(2, '0');
    const minutos = agora.getMinutes().toString().padStart(2, '0');

    const dia = agora.getDate().toString().padStart(2, '0');
    const mes = (agora.getMonth() + 1).toString().padStart(2, '0');
    const ano = agora.getFullYear();

    return `${dia}/${mes}/${ano}`;
};

exports.hourNow = () => {
    const agora = new Date();
    const horas = agora.getHours().toString().padStart(2, '0');
    const minutos = agora.getMinutes().toString().padStart(2, '0');

    const dia = agora.getDate().toString().padStart(2, '0');
    const mes = (agora.getMonth() + 1).toString().padStart(2, '0');
    const ano = agora.getFullYear();

    return `${horas}:${minutos}`;
};

exports.formatParcel = (parcelAndPrice, uf) => {

    if (!parcelAndPrice) {
        return {
            total: "",
            parcelas: "",
        };
    }

    const valorMinimoAceitavel = uf === "PB" ? 170.00 : 100.00;

    // Verifica se parcel é um array, se não for assume 1
    const parcelArray = Array.isArray(parcelAndPrice.parcel) ? parcelAndPrice.parcel : [1];
    const parcel = parcelArray.at(-1);

    const price = parcelAndPrice?.value;

    // Validação de price
    if (typeof price !== "number" || isNaN(price) || price <= 0) {
        return {
            total: "Preço inválido",
            parcelas: "",
        };
    }

    if (price < valorMinimoAceitavel) {
        return {
            total: "",
            parcelas: "",
        };
    }

    const valorParcela = price / parcel;

    return {
        total: `R$ ${price.toFixed(2).replace('.', ',')}`,
        parcelas: `em ${parcel}x de R$ ${valorParcela.toFixed(2).replace('.', ',')} no cartão`,
    };
};



exports.formatParcelOld = (price) => {
    const valorMinimoAceitavel = 170.00
    const parcel = 6;
    const valorParcela = price / parcel;

    if (price < valorMinimoAceitavel) {
        return {
            total: "",
            parcelas: "",
        };
    }

    if (typeof price !== "number" || isNaN(price) || price <= 0) {
        return {
            total: "Preço inválido",
            parcelas: "",
        };
    }

    return {
        total: `R$ ${price.toFixed(2).replace('.', ',')}`,
        parcelas: `em ${parcel}x de R$ ${valorParcela.toFixed(2).replace('.', ',')} sem juros`,
    };
};

exports.contadorPositivo = (contador) => {
    contador++;
    return contador;
};

exports.contadorNegativo = (contador) => {
    if (contador > 1) {
        contador--;

    } else if (contador < 2) {
        contador = contador
    }
    return contador;
};

exports.formatDateString = (dateString) => {
    const [year, month, day] = dateString?.split("-");

    return `${day}/${month}/${year}`;
};